import React from "react";

const Home: React.FC = () => {
    return (
        <div className="min-h-screen relative">
            {/* Background image - portrait */}
            <div className="fixed inset-0 z-0 overflow-hidden">
                <div style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(90deg)",
                    width: "100vh",
                    height: "100vw",
                    backgroundImage: "url('/bg.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}></div>
            </div>

            {/* Background overlay with opacity */}
            <div className="fixed inset-0 z-0 bg-black/30"></div>

            {/* Hero Section */}
            <section className="relative z-10 min-h-[90vh] flex items-center justify-center overflow-hidden">
                {/* Animated background elements */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute -top-40 -right-40 w-80 h-80 bg-accent/10 rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-accent/5 rounded-full blur-3xl animate-pulse delay-1000"></div>
                </div>
            </section>

            {/* Horaires */}
            <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 flex items-center space-x-2 bg-black/70 border border-accent/30 rounded-full px-5 py-2.5 backdrop-blur-sm">
                <svg className="w-4 h-4 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-gray-300 text-sm">Commandes prises en charge de <span className="text-accent font-semibold">18h à 23h</span></span>
            </div>

        </div>
    );
};

export default Home;
